<template>
    <div>
        <q-table
            :data="history"
            :columns="columns_history"
            :pagination.sync="server_pagination"
            @request="requestHistory"
            :loading="loading"
            row-key="id"
            :no-data-label="$t('no_data_avaliable')"
            :no-results-label="$t('no_results_found')"
            :loading-label="$t('loading_data')"
            :rows-per-page-label="$t('items_per_page')"
            :rows-per-page-options="[0]"
            class="q-mt-md"
            binary-state-sort
            >

            <q-tr slot="header" slot-scope="props" :props="props">
                <q-th v-for="col in props.cols" :key="col.name" :props="props">
                    {{ $t(col.label) }}
                </q-th>
            </q-tr>

            <q-tr slot="body" slot-scope="props">
                <q-td key="author_full_name" :props="props">
                    {{ props.row.author_full_name }}
                </q-td>

                <q-td key="author_email" :props="props">
                    {{ props.row.author_email }}
                </q-td>

                <q-td auto-width key="observation_type_slug" :props="props">
                    <q-chip small :icon="getTypeIcon(props.row.observation_type_slug)" :color="getTypeColor(props.row.observation_type_slug)" class="full-width">
                        {{ $t(props.row.observation_type_slug) }}
                    </q-chip>
                </q-td>

                <q-td key="created_date" :props="props">
                    {{ fDate(props.row.created_date) }}
                </q-td>

                <q-td key="observation" :props="props" style="display: flex; align-items: center; height: auto; white-space: break-spaces; min-height: 50px;">
                    {{ props.row.observation }}
                </q-td>
            </q-tr>
        </q-table>

    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { date, debounce } from 'quasar'
const { formatDate } = date

export default {
    name: 'AdminPresentialHistory',

    data() {
        return {
            presential_event_id: '',
            history: [],
            columns_history: [
                {
                    name: 'author_full_name',
                    required: true,
                    label: 'name',
                    align: 'left',
                    field: 'author_full_name',
                    sortable: false,
                },
                {
                    name: 'author_email',
                    required: true,
                    label: 'email',
                    align: 'left',
                    field: 'author_email',
                    sortable: false,
                },
                {
                    name: 'observation_type_slug',
                    required: true,
                    label: 'type',
                    align: 'left',
                    field: 'observation_type_slug',
                    sortable: false,
                },
                {
                    name: 'created_date',
                    required: true,
                    label: 'date',
                    align: 'left',
                    field: 'created_date',
                    sortable: false,
                },
                {
                    name: 'observation',
                    required: true,
                    label: 'observation',
                    align: 'left',
                    field: 'observation',
                    sortable: false,
                },
            ],
            server_pagination: {
                page: 1,
                rowsPerPage: 0,
                descending: false,
                sortBy: null
            },
            loading: false
        }
    },

    computed: {
		...mapGetters({
            access_token: 'common/access_token',
            id_user_language_selected: 'common/id_user_language_selected'
		}),

		getHeader() {
            let headers = {}
            return headers = {
                headers: {
                    'content-type': 'application/json',
                    'authorization': 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
                    'authorization': 'Bearer ' + this.access_token
                }
            }
        }
    },

    methods: {
        requestHistory({ pagination }) {
            this.loading = true
            this.server_pagination = pagination

            let order = pagination.descending ? '-' : ''
            let order_by = pagination.sortBy ? order + pagination.sortBy : ''

            let data = {
                "page_size": this.server_pagination.rowsPerPage,
                "page": this.server_pagination.page,
                "search": '',
                "ordering": order_by
            }

            this.$axios.get(`/presential/presential_events/${this.presential_event_id}/history/?${this.$qs.stringify(data)}`, this.getHeader)
            .then(response => {
                this.server_pagination.rowsNumber = response.data.count

                this.history = response.data.results.map(e => {
                    return { ...e}
                })
            })
            .catch(e => {
                console.log(e)
            })
            .finally(() => {
                this.loading = false
            })
        },

        getTypeIcon(type) {
            if (type === 'approval') return 'fal fa-check'
            else if (type === 'reproval') return 'fal fa-undo'
            else if (type === 'cancel') return 'fal fa-times'
            else if (type === 'finish') return 'fal fa-check-double'
        },

        getTypeColor(type) {
            if (type === 'approval') return 'positive'
            else if (type === 'reproval') return 'warning'
            else if (type === 'cancel') return 'negative'
            else if (type === 'finish') return 'info'
        },

        fDate(d) {
            if (d) {
                let format = ''

                switch(this.id_user_language_selected) {
                    case 1:
                    case 3: format = 'DD/MM/YYYY HH:mm:ss'
                    break
                    default: format = 'MM-DD-YYYY HH:mm:ss'
                    break
                }

                return date.formatDate(d, format)
            }
        },
    },

    created() {
        this.presential_event_id = this.$route.params.id

        this.requestHistory({
            pagination: this.server_pagination
        })
    },
}
</script>

<style>

</style>
